export default __webpack_public_path__ + "static/media/login-background.af0100ca.jpeg";